module.exports = __webpack_public_path__ + "img/3MCircularTT-Bold.0bb10b1b.svg";